import React, { Component } from 'react';
import _find from 'lodash/find'
import _without from 'lodash/without'
import { change } from 'redux-form';

export default class ArrayCheckbox extends Component {

  
  onChange(event) {
    const { input, itemValue } = this.props;

    var oldValues = input.value || [];

    var newValues = _without(oldValues, itemValue); // remove value

    if (event.target.checked) { // was checked
      newValues = itemValue
    }
    else {
      console.log(newValues, input, this.props)
      return input.onChange(null)
    }
    return input.onChange(newValues);
  }


  render() {
    const { input, itemValue} = this.props;
    return (
    <div className="button-group agency-select align-right">
      <input
        id={`_${itemValue}`}
        type="checkbox"
        checked={input.value === itemValue}
        onChange={this.onChange.bind(this)}
        />
        <label className="button hollow" htmlFor={`_${itemValue}`}>Select</label>
    </div>


    );

  }
}



// WEBPACK FOOTER //
// ./src/components/ArrayCheckbox.js